const CLASS_NAME_TO_FUNCTION = {}

function afterSaveAssociationReduxHookUtil (instance, state, options) {
  const { className } = instance
  const fn = CLASS_NAME_TO_FUNCTION[className]
  if (!fn) {
    return state
  }
  return fn(instance, state, options)
}

export default afterSaveAssociationReduxHookUtil
